export const contractTypeOptions = [
    'Proposal',
    'Engagement letter/client contract',
    'Statements of Work or Work Orders',
    'Multi-firm engagement (KPMG China as an originating firm)',
    'Multi-firm engagement (KPMG China as a participating firm)',
    'Local Implementation Agreement',
    'Non-disclosure Agreement',
    'Personal Non-disclosure Agreement / Individual Confidentiality Undertaking',
    'Contract with 3rd party (e.g. subcontractor agreement, alliance agreement)',
    'Simplified (abridged) Chinese engagement letter (for filing purposes in Mainland China)',
    'Others (please explain)'
]

export const invoiceStatusOptions = ['settled', 'open', 'partial paid', 'reversed']

export const fapiaoTypeOptions = ['81','82','85','86','08','10']
